import { render, staticRenderFns } from "./QuotaManage.vue?vue&type=template&id=b23dc81a&scoped=true&"
import script from "./QuotaManage.vue?vue&type=script&lang=js&"
export * from "./QuotaManage.vue?vue&type=script&lang=js&"
import style0 from "./QuotaManage.vue?vue&type=style&index=0&id=b23dc81a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23dc81a",
  null
  
)

export default component.exports